
export function getMap() {
    return elementsPageMap;
}

export function getAdditionalCarrierMap() {
    return additionalCarrierElementsPageMap;
}

export function getReviewTabElements(){
    return reviewTabElements;
}

const elementsPageMap = {
    packingTab:".packing-tab-section-hidden",
    packingTabB2c:".packing-tab-b2c",
    reviewTabB2c:".packingTabB2c",
    b2bPackTab:".b2b-packing-tab",
    business:".b2b-b2b-info-msg",
    b2b:".b2b",
    b2c:".b2c",
    orderTypeRetailerSwitch: '.order-type-retailer-switch',
    orderTypeRetailerSwitchSection: '.specific-retailer-toggle-target',
    orderTypeRetailerList: '.order-type-retailer-list',
    orderTypeDropShipSwitch: '.order-type-dropShip-switch',
    orderTypeNameInput: '.orderTypeNameInput',
    orderTypeCodeInput: '.orderTypeCodeInput',
    orderTypeDuplicateError: "#create-order-type-duplicate",
    orderTypeFullfillmentCenter: '#order_type_fulfillmentCenter',
    orderTypeBillingMethod: '#order_type_billingMethod',
    orderTypeCarrier: '#order_type_carrier',
    carrierDropDownSection: ".carrier-drop-section",
    fedExSection: ".fedex-section",
    upsSection: ".ups-section",
    orderTypeFedexAccountNumber: '.order-type-fedex-account-number',
    orderTypeUpsAccountNumber: '.order-type-ups-account-number',
    orderTypeBillto: '.order-type-billto',
    orderTypeDetailCountry: '.order-type-detail-country',
    orderTypeDetailAddress: '.order-type-detail-address',
    orderTypeDetailAddress2: '.order-type-detail-address2',
    orderTypeDetailCity: '.order-type-detail-city',
    orderTypeDetailState: '.order-type-detail-state',
    orderTypeDetailStateInput: '.order-type-detail-state-input',
    orderTypeDetailPostalcode: '.order-type-detail-postalcode',
    destinationTabStateTextWrapper: '.destination-tab-stateText-wrapper',
    orderTypeDetailStateDropdown: '.order-type-detail-state-dropdown',
    orderTypeDetailAddcarrier: '.order-type-detail-addcarrier',
    orderTypedetailAddcarrierDiv: '.order-type-detail-addcarrier-div',
    orderDestinationTabFfcMsg: ".order-destination-tab-ffc-msg",
    errorText : ".errorText",
    dupErrorText : ".dupErrorText",
    orderTypeBoxType : "#order-type-boxType",
    orderTypeTissuePaper : "#order-type-tissuePaper",
    orderPackingSlip : "#order-packing-slip",
    includePackageDiv: ".includePackageDiv",
    packagePackingSlip : "#package-packing-slip",
    orderTypeCountryCode : "#order-type-countryCode",
    facilityAddress : "#order-type-facility",
    packageSlip : "#order-type-package-slip",
    orderSlip: "#order-type-order-slip",
    boxTypeDesc: "#boxType-desc",
    tissuePaperDesc: "#tissuePaper-desc",
    customizeSection: '.customize-section',
    orderTypeFacilityAddrss1: '#order-type-facility-add-1',
    orderTypeFacilityAddrss2: '#order-type-facility-add-2',
    companyNameInput :".companyNameInput",
    customDocEmail: "#order-type-custom-doc-email",
    customHeader:".customHeader",
    customBody:".customBody",
    includePackageLabel:".includePackageLabel",
    customDocPhoneNumber:".phone-number"
};

const additionalCarrierElementsPageMap = {

    additionalCarrierDrop: '.additionalCarrierDrop',
    fedexAccountNumber: "#fedexAccountNumber",
    upsAccountNumber: "#upsAccountNumber",
    additionalCarrierBillTo : ".additional-carrier-billTo",
    additionalCarrierCountry : ".additional-carrier-country",
    additionalCarrierAddress1 : ".additional-carrier-address1",
    additionalCarrierAddress2 : ".additional-carrier-address2",
    additionalCarrierCity : ".additional-carrier-city",
    additionalCarrierDetailState :".additional-carrier-detail-state",
    additionalCarrierDetailStateText : ".additional-carrier-detail-state-text",
    additionalCarrierPostalCode : ".additional-carrier-postalCode",
    additionalCarrierDetailStateWrapper : ".additional-carrier-detail-state-wrapper",
    additionalCarrierDetailStateTextWrapper : ".additional-carrier-detail-state-text-wrapper",
    orderTypeDetailRemove:".order-type-detail-remove",
    additionalCarrierMainDiv:".additional-carrier",
    additionalCarrierFedexNumber:'.additional-carrier-fedexnumber',
    additionalCarrierUPSNumber:'.additional-carrier-upsnumber'
};

const reviewTabElements = {
    sectionTitlesReviewTab:".section-step-title-inner",
    specifiedRetailerSection: ".specified-retailer-seciton",
    retailerName: ".spec-retailer-name",
    dropShippingNo: ".dropShipNo",
    dropShippingYes: ".dropShipNoYes",
    detailsSection: ".detailsSection",
    orderTypeName: ".order-type-name",
    orderTypeCode: ".order-type-code",
    fulfillmentCenterSection: ".fulfillmentSection",
    fulfillmentCenter: ".fulfillment-center",
    carrierSection: ".carrierSection",
    billMethod: ".bill-method",
    nonPrepaidLabels: ".non-prepaid",
    carrierName: ".carrier-name",
    accountNumber: ".account-number",
    billToName: ".bill-to-name",
    billToAddressLine: ".address-line",
    cityStatePostalCode: ".city-state-postalCode",
    billToCountry: ".country",
    additionalCarrierSection: ".additional-carrier-section",
    additionalCarrierName: ".additional-carrier-name",
    nonFedExSection: ".non-fedex",
    additionalCarrierAccountNumber: ".additional-carrier-number",
    additionalNonFedEx: ".additional-non-fedex",
    additonalBillToName: ".additional-bill-to-name",
    additionalBillToAddressLine: ".additional-address-line",
    additionalCityStatePostalCode: ".additional-city-state-postalCode",
    additionalBillToCountry: ".additional-country",
    orderPackingSection: ".order-packing-section",
    boxType: ".box-type",
    boxTypeCost: ".box-type-cost",
    tissuePaper: ".tissue-paper",
    tissuePaperCost: ".tissue-paper-cost",
    orderDocumentSection: ".order-document-section",
    packageLevelSlipOn: ".package-level-slip-on",
    packageLevelSlipOff: ".package-level-slip-off",
    packageLevelSlipTemplate: ".package-level-slip-template",
    orderLevelSlipOn: ".order-level-slip-on",
    orderLevelSlipOff: ".order-level-slip-off",
    orderLevelSlipTemplate: ".order-level-slip-template",
    includeLabelOn: ".include-label-on",
    includeLabelOff: ".include-label-off",
    includeLabelDiv: ".includeLabelDiv",
    customDocSection: ".customized-document-section",
    customDocName: ".custom-doc-name",
    customDocFacilityName: ".custom-doc-facility-name",
    customDocAddressLine: ".custom-doc-address-line",
    customDocCityState: ".custom-doc-city-state",
    customDocPhone: ".custom-doc-phone-number",
    customDocEmail: ".custom-doc-email",
    customDocHeader: ".custom-doc-header",
    customDocBody: ".custom-doc-body",
    submitBtn: ".submit-order-type-wizard"
};


// WEBPACK FOOTER //
// ./src/pages/orderType/elementsbindMap.js